const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '조치 완료일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {'component': 'search-disaster-types', label: '재해형태', value: 'disaster', query: {'dty': 'disaster'}, options: {}},
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['요청일', '재해형태', '조치 완료일', '작성일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  조치 완료일
    if (search.date) {
      conditions.push({key: 'body.inputE_6', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.inputE_6', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.inputC_6', operator: '=', value: `${search.disaster}`})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "요청자 구분",
        "key": "body.type"
      },
      {
        "name": "요청일",
        "key": "body.inputC_8"
      },
      {
        "name": "재해형태",
        "key": "body.inputC_6"
      },
      {
        "name": "조치 현황",
        "key": "body.inputE_5"
      },
      {
        "name": "조치 완료일",
        "key": "body.inputE_6"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "작성일",
        "key": "created_at"
      }
    ]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // func.getContent(value).targetCompany.com_name // 사업장명
        case 1: return func.getContent(value).type // 요청자 구분
        case 2: return func.getContent(value).inputC_8 // 요청일
        case 3: return func.getContent(value).inputC_6 // 재해형태
        case 4: return func.getContent(value).inputE_5 // 조치현황
        case 5: return func.getContent(value).inputE_6 // 조치완료일
        case 6: return func.getContent(value).stdInfo.section // 부서명
        case 7: return func.getContent(value).stdInfo.writer_name // 작성자
        case 8: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
